// takes something like "some_snake_case" and returns "Some Snake Case"
export const convertSnakeCaseToTitleCase = ( snakeCase: string ): string => {
	return snakeCase.replace( /_/g, ' ' ).split( ' ' ).map( ( word ) => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) ).join( ' ' )
}

// takes something like "some_snake_case" and returns "someSnakeCase"
export const convertSnakeCaseToCamelCase = ( snakeCase: string ): string => {
	return snakeCase.replace( /_([a-z])/g, ( _, letter ) => letter.toUpperCase() )
}

// Characters that are stripped from pasted payload values so credentials work when copy-pasted:
// Line breaks: \\r\\n, \\r, \\n
// Tab: \\t
// Non-breaking space (U+00A0) — common from web/Word
// BOM / zero-width no-break space (U+FEFF) — can appear at start when pasting from some apps
// Zero-width space (U+200B), non-joiner (U+200C), joiner (U+200D), word joiner (U+2060) — invisible, often from web/PDF
const PASTE_ARTIFACTS_REGEX = /\r\n|\r|\n|\t|\u00A0|\uFEFF|\u200B|\u200C|\u200D|\u2060/g

export const normalizePayloadString = ( value: unknown ): string => {
	if ( value === undefined || value === null ) {
		return ''
	}
	const str = typeof value === 'string' ? value : String( value )
	return str.trim().replace( PASTE_ARTIFACTS_REGEX, '' )
}

export const noWrapTime = ( text: string ) => text.replace( /(\d{1,2}:\d{2})\s+(AM|PM)/gi, '$1\u00A0$2' )
